/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Approve_Overage_OffInputs */



/**
* | output |
* | --- |
* | "Pay-per-use after the budget: off — usage stops at the budget." |
*
* @param {Partner_Org_Contract_Approve_Overage_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_overage_off = /** @type {((inputs?: Partner_Org_Contract_Approve_Overage_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_Overage_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbasierte Abrechnung nach dem Budget: aus — die Nutzung endet am Budget.")
	return /** @type {LocalizedString} */ ("Pay-per-use after the budget: off — usage stops at the budget.")
});